import React, { useContext } from "react";
import { HubContext } from "Redux/Context/context";
import { VegaFlex } from "@heartlandone/vega-react";
import Activity from "Views/MyActivity/ActivityItem/Index";

function RegisteredActivityList() {
  const { myActivitiesState } = useContext(HubContext);
  return (
    <VegaFlex direction={"col"} gap={"size-16"}>
      {myActivitiesState.activities?.map((activity, index) => {
        return <Activity key={index} activity={activity} />;
      })}
    </VegaFlex>
  );
}

export default RegisteredActivityList;
